module.exports = __webpack_public_path__ + "img/blue_110.9447a1f3.png";